"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vueKeyType = void 0;

var _vueTypes = require("vue-types");

var vueKeyType = function vueKeyType() {
  return (0, _vueTypes.oneOfType)([(0, _vueTypes.string)(), (0, _vueTypes.number)()]);
};

exports.vueKeyType = vueKeyType;